<template>
    <el-drawer title="实名管理" :visible.sync="realNameVisible" :before-close="closeDialog" size="auto" class="realname-box">
        <div class="drawer-content">
            <el-form :model="realNameForm" :rules="rules" ref="realNameForm">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="realNameForm.name" autocomplete="off" size="medium" placeholder="请输入姓名" maxlength="40" show-word-limit ></el-input>
                </el-form-item>
                <el-form-item prop="documentNumber">
                    <template slot="label">
                        <span>证件</span>
                        <span class="realname-tips">
                            证件信息目前只能填写一项，新的证件信息会覆盖旧的证件信息
                        </span>
                    </template>
                    <el-input
                        v-model="realNameForm.documentNumber" 
                        class="input-with-select" 
                        size="medium" 
                        style="display: inline-table;">
                        <!-- <el-select v-model="realNameForm.documentType" slot="prepend" placeholder="请选择">
                            <el-option label="身份证" :value="1"></el-option>
                            <el-option label="港澳居民来往内地通行证" :value="2"></el-option>
                            <el-option label="台湾居民来往大陆通行证" :value="3"></el-option>
                            <el-option label="护照" :value="4"></el-option>
                            <el-option label="外国人永久居留身份证" :value="5"></el-option>
                            <el-option label="港澳台居民居住证" :value="6"></el-option>
                        </el-select> -->
                        <el-select v-model="realNameForm.documentType" slot="prepend" placeholder="请选择证件类型" @change="$refs['realNameForm'].validate('documentNumber')" style="width: 160px;">
                            <el-option v-for="(item,index) in documentTypeList" :key="index" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
        </div>
    </el-drawer>
</template>

<script>
export default {
    props: {
        realNameVisible: {
            type: Boolean,
            default: false
        },
        editData: {
            type: Object,
            default: ()=> {}
        }
    },
    watch: {
        realNameVisible(n){
            if(n){
                const data = {
                    ...this.editData,
                    documentType: this.documentTypeList.find(i=> i.label == this.editData.documentType).value
                };
                // const arr = ['idNum', 'hongKongMacauNum', 'twNum', 'passPortNum'];
                // arr.forEach((item, idx)=> {
                //     if(data[item] !== '无'){
                //         data.documentType = idx + 1;
                //         data.documentNumber = data[item];
                //     }
                // })
                this.realNameForm = {...data};
            }            
        }
    },
    data(){
        const checkLength = (rule, value, callback) => {            
            const arr = [null, ...this.documentTypeList.map(v => v.label)];
            let len = 18, msg = `${arr[this.realNameForm.documentType]}`;
            if(this.realNameForm.documentType != 1){
                len = 20;
                msg += `最多允许填写20个字符` 
            }else{
                msg += `格式错误` 
            }
            if (value.length > len || this.realNameForm.documentType == 1 && value.length != len) {
                callback(new Error(msg));
            } else {
                callback();
            }
        }
        return {
            realNameForm: {
                name: '',
                documentType: 1,
                documentNumber: ''
            },
            submitLoading: false,
            rules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                documentNumber: [
                    { required: true, message: '请输入证件号码', trigger: 'blur' },
                    { validator: checkLength, trigger: 'blur' }
                ]
            }                   
        }
    },
    computed:{
        documentTypeList(){
            return [{
                label:'身份证',
                value:1
            },{
                label:'港澳居民来往内地通行证',
                value:2
            },{
                label:'台湾居民来往大陆通行证',
                value:3
            },{
                label:'护照',
                value:4
            },{
                label:'外国人永久居留身份证',
                value:5
            },{
                label:'港澳台居民居住证',
                value:6
            }]
        }
    },
    methods: {
        submitForm(){
            this.$refs['realNameForm'].validate((valid) => {
                if(valid){
                    this.submitLoading = true;
                    this.$request({
                        url: '/commonPerformer/updatePerformer',
                        method: "POST",
                        data: {...this.realNameForm}
                    }).then(res=>{
                        const {state, msg} = res.data;
                        if (state == 1) {
                            this.$message.success('更新成功');
                            this.closeDialog();
                            this.$parent.search();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    }).catch(() => {
                        this.$message.error("请求错误");
                    }).finally(()=>{
                        this.submitLoading = false;
                    })
                }
            })            
        },
        closeDialog(){
            this.$emit('update:realNameVisible', false);
            this.$nextTick(()=>{
                this.$refs['realNameForm'].clearValidate();     
            })              
        }
    }
}
</script>
<style lang="scss">
.realname-box{
    .realname-tips{
        display: inline-block;
        width: 336px;
        margin-left: 10px;
        font-size: 12px;
        line-height: 12px;
        color: #909399;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>